/**
 * White-label branding for the AI tutor.
 *
 * Configure per deployment via env vars (frontend/.env or build args):
 *   VITE_TUTOR_NAME   — tutor persona / product name (default: Speakalot)
 *   VITE_TUTOR_AVATAR — path to the tutor photo, relative to /public
 *                       (default: /photo.jpeg)
 *
 * Translation values use the %TUTOR% token which is substituted when the
 * messages are loaded (see shared/translations/messages.ts). The backend
 * counterpart is DJANGO_TUTOR_NAME (see tutorwebapp/branding.py).
 */

import {
  DEFAULT_TUTOR_AVATAR,
  DEFAULT_TUTOR_NAME,
} from './brandingDefaults.ts'

export const TUTOR_NAME: string =
  import.meta.env.VITE_TUTOR_NAME ?? DEFAULT_TUTOR_NAME

export const TUTOR_AVATAR: string =
  import.meta.env.VITE_TUTOR_AVATAR ?? DEFAULT_TUTOR_AVATAR

export const TUTOR_TOKEN = '%TUTOR%'

export function applyBranding(text: string): string {
  return text.split(TUTOR_TOKEN).join(TUTOR_NAME)
}

export function brandMessages<T extends Record<string, string>>(
  messages: T,
): T {
  return Object.fromEntries(
    Object.entries(messages).map(([key, value]) => [
      key,
      applyBranding(value),
    ]),
  ) as T
}
